var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello container"},[(_vm.loading === true)?_c('div',{staticStyle:{"background-color":"rgba(56, 74, 35, 0.67)","position":"absolute","top":"0","left":"0","height":"100vh","width":"100vw","z-index":"999","overflow":"hidden","display":"flex","align-items":"center","justify-content":"center"}},[_c('HourGlass')],1):_vm._e(),_c('h3',[_vm._v("Personas con suscripciones")]),_c('div',{staticClass:"container mt-3 mb-3"},[_c('div',{staticClass:"container mb-3"}),_c('vue-good-table',{attrs:{"columns":_vm.columns,"rows":_vm.arrayPersonas,"pagination-options":{
        enabled: true,
        mode: 'records',
        perPage: 10,
        position: 'top',
        perPageDropdown: [15, 20, 25],
        dropdownAllowAll: false,
        setCurrentPage: 1,
        nextLabel: 'Proximo',
        prevLabel: 'Anterior',
        rowsPerPageLabel: 'Filas por Pagina',
        ofLabel: 'de',
        pageLabel: 'Pagina', // for 'pages' mode
        allLabel: 'Todas',
      },"search-options":{
        enabled: true,
        trigger: 'enter',
        skipDiacritics: true,
        placeholder: 'Buscar',
      }}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }